import React from "react";

import type { FC, SVGAttributes } from "react";

export const ArrowIcon: FC<SVGAttributes<SVGElement>> = (props) => {
  return (
    <svg viewBox="0 0 16 16" fill="none" {...props}>
      <path d="M13.3327 7.33268H5.21935L8.94602 3.60602L7.99935 2.66602L2.66602 7.99935L7.99935 13.3327L8.93935 12.3927L5.21935 8.66602H13.3327V7.33268Z" />
    </svg>
  );
};
